import './js/wds-algolia-search-pro';